import React, {Component} from "react";
import Loading from "../../components/Loading";
import GraphQLErrors from "../../components/GraphQLErrors";
import gql from "graphql-tag";
import {connect} from "react-redux";
import {fromJS} from "immutable";
import {graphql} from "react-apollo";
import {longDateFormat, dateWithTimeFormat} from "../../lib/DateFormatter";
import Conditional from "../../components/Conditional";
import MetaTable from "../../components/MetaTable";
import {formatSalesOrderStatus} from "../../lib/SalesOrderStatus";
import "./ChargeView.css";


class ChargeView extends Component {

  componentDidMount() {
    if (this.props.salesOrderId && !this.unsubscribe) {
      this.subscribe(this.props.salesOrderId);
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.salesOrderId && (prevProps.salesOrderId !== this.props.salesOrderId)) {
      this.subscribe(this.props.salesOrderId);
    }
  }

  subscribe(salesOrderId) {
    if (this.unsubscribe) {
      this.unsubscribe();
    }
    this.unsubscribe = this.props.subscribeToUpdates(this.props, {});
  }

  render() {
    let {loading, error} = this.props.data;
    if (loading) return <Loading />
    if (error) return <GraphQLErrors error={error} />        
    const charge = fromJS(this.props.data.billingChargeForSalesOrder);

    let reasonText = null;
    if (charge.get("status") === "voided" || charge.get("status") === "cancelled") {
      reasonText = `(${charge.get("reason", "")})`
    }

    return (
      <div className="ChargeView">
        <MetaTable>
          <tr>
            <th>Invoice Nr</th>
            <td>{charge.get("invoiceNr")}</td>
          </tr>
          <tr>
            <th>Amount</th>
            <td>{charge.get("amount")} {charge.get("currency")} (balance: {charge.get("balance")} {charge.get("currency")})</td>
          </tr>
          <tr>
            <th>Status</th>
            <td>{formatSalesOrderStatus(charge.get("status"))} {reasonText}</td>
          </tr>
          <Conditional show={charge.get("paymentTermsDays") > 0}>
            <tr>
              <th>Payment Terms</th>
              <td>{charge.get("paymentTermsDays")} days. Due on {longDateFormat(charge.get("dueAt"))}.</td>
            </tr>
          </Conditional>
          <Conditional show={charge.get("status") === "failed"}>
            <tr>
              <th>Last attempt</th>
              <td>{dateWithTimeFormat(charge.get("lastAttemptedAt"))}</td>
            </tr>
            <tr>
              <th>Error</th>
              <td>{charge.get("lastErrorMessage")} ({charge.get("lastErrorCode")})</td>
            </tr>
            <tr>
              <th>Decline code</th>
              <td>{charge.get("lastDeclineCode")}</td>
            </tr>
          </Conditional>
          <Conditional show={charge.get("status") === "failed" && charge.get("willRetry")}>
            <tr>
              <th>Retry</th>
              <td>Will retry on {dateWithTimeFormat(charge.get("retryAt"))}</td>
            </tr>
            <tr>
              <th>Failed attempts</th>
              <td>{charge.get("failedAttempts")}</td>
            </tr>
          </Conditional>
        </MetaTable>      
      </div>
    )
  }
}

const CHARGE_INFO = gql`
  query charge($salesOrderId: ID!) {
    billingChargeForSalesOrder(salesOrderId: $salesOrderId) {
      kind
      paymentTermsDays
      amount
      balance
      currency
      status
      invoiceNr
      lastErrorCode
      lastDeclineCode
      lastErrorMessage
      willRetry
      retryAt
      reason
      failedAttempts
      lastAttemptedAt    
      dueAt  
      createdAt
    }
  }
`

const ON_UPDATED_BILLING_CHARGE = gql`
  subscription onUpdatedBillingCharge($salesOrderId:ID!) {
    updatedBillingCharge(salesOrderId: $salesOrderId) {
      salesOrderId
    }
  }
`

const mapDispatchToProps = dispatch => ({
  subscribeToUpdates: (props, params) => {
    return props.data.subscribeToMore({
      document: ON_UPDATED_BILLING_CHARGE,
      variables: {
        salesOrderId: props.salesOrderId
      },
      updateQuery: (prev, { subscriptionData }) => {
        props.data.refetch();
        return prev;
      }
    })
  }
})

const withSubscription = connect(null, mapDispatchToProps);

const withQuery = graphql(CHARGE_INFO, {
  options: (props) => ({
    fetchPolicy: "cache-and-network",
    variables: {
      salesOrderId: props.salesOrderId
    }
  })
})


export default withQuery(withSubscription(ChargeView));